export default {"src":"/_next/static/media/studio.3fa79f05.svg","height":859,"width":1804,"blurWidth":0,"blurHeight":0};